module.exports = __webpack_public_path__ + "static/flow3-d1b6be040fa1558b93ff7ceed1e79c2a.svg";